export const STATION_REQUEST = 'STATION_REQUEST';
export const STATION_SUCCESS = 'STATION_SUCCESS';
export const STATION_FAILURE = 'STATION_FAILURE';
